import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import React, { useEffect } from "react";

import useRefreshLocationData, {
  RefreshType
} from "../../../../containers/FacilityDetailsPage/hooks/useRefreshLocationData";
import { ReviewData } from "../../../../models/ReviewData";
import DataSvc from "../../../../services/dataSvc";

const useUnrepliedReviewsList = (locationId: string) => {
  const { data: unRepliedReviews, status } = useQuery(
    ["unRepliedReviews", locationId],
    () => {
      if (!locationId) return [];
      const now = dayjs();
      return DataSvc.getFacilityReviews({
        locationId: locationId,
        periodFromDate: dayjs(now).subtract(60, "days").format("YYYY-MM-DD"),
        periodToDate: dayjs(now).format("YYYY-MM-DD"),
        isReplied: 0,
        sort: "review_date",
        order: "desc"
      });
    }
  );

  const [unRepliedReviewList, setUnRepliedReviews] =
    React.useState<ReviewData[]>(unRepliedReviews);

  useEffect(() => {
    if (unRepliedReviews?.length > 0) {
      setUnRepliedReviews(unRepliedReviews);
    } else {
      setUnRepliedReviews([]);
    }
  }, [unRepliedReviews]);

  const refreshLocationData = useRefreshLocationData(locationId);

  const onDeleteReviewItem = async (reviewId: string) => {
    setUnRepliedReviews((previousReviewList) =>
      previousReviewList.filter((r) => r.review_id !== reviewId)
    );

    refreshLocationData(RefreshType.LOCATION, RefreshType.UN_REPLIED_REVIEWS);
  };

  return { unRepliedReviewList, onDeleteReviewItem, status };
};

export default useUnrepliedReviewsList;
